// alarmAudioPreference.js
// Preferência de áudio do operador, entre sessões do navegador.
//
// Guarda VOLUME e SILENCIAMENTO — estado puro, aplicado de imediato na
// abertura, sem depender de gesto nenhum.
//
// O que NÃO se guarda é "o áudio está liberado": isso não é persistível. A
// política de autoplay dos navegadores exige um gesto do operador a CADA
// carregamento de página, e nenhum armazenamento contorna isso.
//
// Houve aqui um campo `enabled` que registrava "este operador já pediu som",
// usado para aceitar qualquer clique da aplicação como o gesto exigido. Foi
// removido: ligava o som enquanto o operador fazia outra coisa e trocava o
// conteúdo do aviso sem que ele tivesse pedido. Quem liga o som é o botão.
//
// Usa localStorage e não sessionStorage: a intenção vale entre sessões e entre
// abas, que é justamente o incômodo a resolver.
//
// LGPD: guarda uma escolha de interface (ligado, mudo, volume). Nenhum dado
// pessoal, nenhum token, nenhuma credencial.

// Escopada por operador, como o retrato: numa estação compartilhada, a escolha
// de quem estava antes não pode valer para quem assumiu o turno.
const STORAGE_PREFIX = "overview.alarmes-criticos.audio";

const keyFor = (scope) => `${STORAGE_PREFIX}.${scope || "anonimo"}`;

const DEFAULTS = { muted: false, volume: null };

export const loadAudioPreference = (scope) => {
  try {
    const raw = window.localStorage.getItem(keyFor(scope));
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return { ...DEFAULTS };
    }
    // Checagem de TIPO antes de qualquer coerção. `Number(null)` é 0, e
    // `JSON.stringify` grava Infinity como null — sem esta guarda, um volume
    // corrompido viraria volume zero: alarme inaudível sem o operador saber,
    // que é o pior desfecho possível desta feature.
    const volume =
      typeof parsed.volume === "number" ? parsed.volume : Number.NaN;
    return {
      muted: parsed.muted === true,
      // Fora da faixa também é descartado, nunca saturado.
      volume:
        Number.isFinite(volume) && volume >= 0 && volume <= 1 ? volume : null,
    };
  } catch {
    return { ...DEFAULTS };
  }
};

export const saveAudioPreference = (scope, preference) => {
  try {
    const atual = loadAudioPreference(scope);
    window.localStorage.setItem(
      keyFor(scope),
      JSON.stringify({ ...atual, ...preference }),
    );
  } catch {
    // Sessão sem armazenamento disponível não pode derrubar a notificação: o
    // operador volta a habilitar pelo botão, como antes desta preferência.
  }
};

export const clearAudioPreference = (scope) => {
  try {
    window.localStorage.removeItem(keyFor(scope));
  } catch {
    // Idem: falha ao limpar não é condição de erro para o operador.
  }
};
